import React from 'react';
import Page from 'components/Page';
import Pattern from 'components/Pattern';
import connectToStores from 'flummox/connect';
import PureComponent from 'components/PureComponent';
import {canUseDOM} from 'react/lib/ExecutionEnvironment';
import DocumentTitle from 'react-document-title';

const colors = {
	'normal': 'rgba(0,77,176,0.2)',
	'success': 'rgba(32,255,127,0.5)',
	'fail': 'rgba(255,63,14,0.5)'
};

//It a stub component for showing correct background above form
//See components/CodeForm for real form

class Form extends PureComponent {

	componentWillMount() {
		if(canUseDOM) {
			const appStateActions = this.props.flux.getActions('appState');
			appStateActions.openForm();
		}
	}

	render() {
		const pageProps = {
			style: {
				backgroundImage: `url(${this.props.backgroundImage[0]})`,
			}
		};
		const color = colors[this.props.status];

		return (
			<Page {...pageProps}>
				<DocumentTitle title="Проверка подлинности — Глубинная байкальская вода BAIKAL430" />
				<Pattern left="35%" colorLeft={color} colorRight={color} />
			</Page>
		);
	}

}

export default connectToStores(Form, 'codeForm');



// WEBPACK FOOTER //
// ./src/pages/Form/Form.js